import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_API_BASE_URL;

export const bookingApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.bookingApi +
    "?type=" +
    data?.type +
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&location=" +
    (data?.location ? data?.location : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const revenueApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.revenueApi +
    "?type=" +
    data?.type +
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&location=" +
    (data?.location ? data?.location : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const revenueMatrixApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  const endpoint = data?.tabValue === 'booking' ? API_ENDPOINT.Report.bookingMatrixApi : API_ENDPOINT.Report.revenueMatrixApi
  let url = `${env}${
    endpoint +
    "?type=" +
    data?.type +
    "&status=" +
    (data?.status ? data?.status : '') +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&location=" +
    (data?.location ? data?.location : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const revenueExportApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  const endPoint = data?.tabName === "trip-export" ? API_ENDPOINT.Report.bookingExportApi : (API_ENDPOINT.Report.revenueExportApi +data?.tabName)
  let url = `${env}${
    endPoint+
    "?type=" +
    data?.type +
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize +
    "&location=" +
    (data?.location ? data?.location : "") +
    "&export=" +
    (data?.export ? data?.export : "")+
    "&location=" +
    (data?.location ? data?.location : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const customerMatrixApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.customerMatrixApi +
    "?type=" +
    data?.type +
    "&status=" +
    data?.status +
    "&dateFrom=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&dateTo=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize +
    "&location=" +
    (data?.location ? data?.location : "")
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const couponReportFetchApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.couponReportApi +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const couponReportExportApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.couponReportApi +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")+
    "&export=true"
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripDetailsReportFetchApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.tripDetailsReportAPI +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripDetailsReportExportApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.tripDetailsReportAPI +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")+
    "&export=true"
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripBookingReportFetchApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.tripBookingReportAPI +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const tripBookingReportExportApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.Report.tripBookingReportAPI +
    "?startDate=" +
    (data?.dateFrom ? data?.dateFrom : "") +
    "&endDate=" +
    (data?.dateTo ? data?.dateTo : "") +
    "&page=" +
    page +
    "&pageSize=" +
    data.pageSize+
    "&city=" +
    (data?.location ? data?.location : "")+
    "&export=true"
  }`;

  if(data?.type) {
    url = url + "&tripType=" +
    data?.type;
  }
  
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const requestCouponReportApi = async (data) => {
  const payload = {
    startDate: data?.startDate || "",
    endDate: data?.endDate || "",
    reportType: data?.reportType || "COUPON",
    reportFormate: data?.reportFormate || "csv",
    filters: {
      city: data?.city || "",
      tripType: data?.tripType || ""
    }
  };

  const res = await requestInstance
    .post(`${env}/admin-api/v3/tasks/report`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
}
